import tracker from "@/assets/js/statistics/xkw.tracker";
import {
  addCourse,
  addTextbook,
  getCourseDetail,
  getCourseList,
  getLastUsedCourse,
  getSchoolStages,
  getStages,
  getStageSubjectList,
  getTextbookDetail,
  getUserCoursesBooks,
  getUserUsedCourse,
  updateLastUsedCourse,
} from "@/utils/apis";
import { Message } from "element-ui";
import Cookie from "js-cookie";
import { mapMutations, mapState } from "vuex";
const CURRENTCOURSE = "CURRENTCOURSE";
const CURRENTREADCOURSE = "CURRENTREADCOURSE";
// 使用范围
const USESCOPE = "USESCOPE";
const pageIndex = 1;
const userSettingTextBookId = "userSettingTextBookId";
function handleFirstUseScope() {
  // debugger;
  let useScope = Cookie.get(USESCOPE);
  if (useScope) {
    let useScopeArr = useScope.split("|");
    let [year, term, grade] = useScopeArr;

    return {
      year,
      term,
      grade,
    };
  } else {
    return {
      year: "",
      term: "",
      grade: "",
    };
  }
}
export default {
  // inject: ["textbook"],
  data() {
    return {
      // 用户当前选中的课程
      // currentCourse: {},
      // 是否显示我的课程
      isBagVisible: false,
      // 添加教材
      isAddCourseVisible: false,
      bookDialogVisible: false,
      // 学段学科
      stages: [],
      pageSize: 30,
      isLoading: false,
      // 用户有权限的学段学科
      stageListAndSubjects: [],
      // 产品类型id
      productId: 0,
      // 用户的课程
      // userCourses: [],
    };
  },
  computed: {
    ...mapState({
      currentCourse: "currentCourse",
      userCourses: "userCourses",
      userInfo: "userInfo",
      // 用户权限
      userRoles: "userRoles",
      stageSubjectList: "stageSubjectList",
      hasAiUsedCourses: "hasAiUsedCourses",
    }),
  },
  methods: {
    ...mapMutations([
      "setTextbooks",
      "setCourses",
      "setCurrentCourse",
      "changeIsAddNoAuthorizedCourse",
      "setShowUserCourse",
      "setCurrentReadCourse",
      "changeStageSubjectList",
      "changeHasAiUsedCourses",
    ]),
    async getCurrentCourse(courses, isSelectCourse = false, productId = 0) {
      let path = this.$route.path;
      let isWelcomePage = path.indexOf("/welcome") > -1;
      let isExcludePage =
        path == "/" || path == "/desktop" || path.indexOf("/zyk") > -1;
      let isZyk = path.indexOf("/zyk") > -1;
      let { from, stageId, subjectId } = this.$route.query;
      let currentCourse = null;
      let currentCourseId = 0;
      let userPreference = null;
      let newCurrentCourse = null;
      let data = await getLastUsedCourse({
        productId: this.productId || productId,
      });
      let { result } = data;
      if (
        (!result ||
          !result.courseId ||
          !result.stageId ||
          !result.subjectId ||
          (isZyk && from == "xkw")) &&
        !this.isInIframe
      ) {
        // 没有选择过课程的话选择课程列表中的第一个为当前课程
        if (isExcludePage) {
          // 如果是排除的页面从本地中获取当前课程
          currentCourse = localStorage.getItem(
            `${this.userInfo.userId}-` + CURRENTCOURSE
          );
          currentCourse = currentCourse ? JSON.parse(currentCourse) : null;
          if (isZyk && from == "xkw") {
            // console.log('资源库并且从学科网过来的')
            currentCourse = {
              stageId,
              subjectId,
            };
          }
          // console.log('----currentCourse-----',currentCourse,courses)
          if (currentCourse) {
            let { stageId, subjectId } = currentCourse;
            for (let i = 0; i < courses.length; i++) {
              let item = courses[i];
              if (item.id == stageId) {
                // console.log('---item',item)
                if (item?.courseList?.length) {
                  let course = item.courseList.find(
                    (course) => course.subjectId == subjectId
                  );
                  if (course) {
                    // console.log('course',course)
                    currentCourse = course;
                    // return;
                  }
                }
              }
            }
            // console.log('currentCourse---',currentCourse)
            if (!currentCourse.isUse) {
              let { result } = await addCourse({
                stageId,
                subjectId,
              });
              // console.log('result',result)
            }
            // 需要更新当前课程
            let data = await updateLastUsedCourse({
              stageId,
              subjectId,
              productId: this.productId,
            });
            if (data.result) {
              currentCourse.isLastUsedCourse = true;
            }
          } else {
            currentCourse = courses[0].courseList[0];
            currentCourse.stageId = courses[0].id;
            currentCourse.stageName = courses[0].name;
            currentCourse.isLastUsedCourse = false;
          }
        } else {
          currentCourse = result;
          // currentCourse.isLastUsedCourse = false
        }
        // console.log("currentCourse-----", currentCourse);
        this.setCurrentCourse(currentCourse);
        this.setShowUserCourse([currentCourse]);
      } else {
        // 如果有上次的课程 先判断是否嵌入到iframe中获取用户偏好
        if (
          this.isInIframe &&
          this.$refs.xepAside &&
          this.$refs.xepAside.getUserPreferenceApi
        ) {
          userPreference = await this.$refs.xepAside.getUserPreferenceApi();
          userPreference = userPreference?.body?.preferenceData;
        }
        // console.log("偏好userPreference", userPreference);
        currentCourseId =
          this.isInIframe && !isSelectCourse && userPreference
            ? userPreference.courseId
            : result.courseId;
        // console.log("currentCourseId", currentCourseId);
        if (currentCourseId) {
          // 判断cookie中的当前课程与接口中的课程是否一致
          //  这块处理时为了当像同步页面的时候切换教材保存到所在课程中的时候，需要重新获取用户课程并且重新存储当前的课程 这时候需要判断当前的cookie是否与最新的一致如果不一致需要更新cookie值
          for (let i = 0; i < courses.length; i++) {
            let item = courses[i];
            if (item?.courseList?.length) {
              newCurrentCourse = item.courseList.find(
                (course) => course.courseId == currentCourseId
              );
              // console.log("newCurrentCourse1", newCurrentCourse);
              if (newCurrentCourse) {
                newCurrentCourse.stageId = item.id;
                break;
              }
            }
          }
          // 先判断是否在权限之内如果不在的话
          // console.log("newCurrentCourse", newCurrentCourse);
          // console.log("newCurrentCourse", newCurrentCourse,userPreference);
          if (newCurrentCourse) {
            currentCourse = newCurrentCourse;
            // console.log("currentCourse====", currentCourse);
          } else {
            currentCourse = courses[0].courseList[0];
            currentCourse.stageId = courses[0].id;
            currentCourse.stageName = courses[0].name;
          }
          this.setCurrentCourse(currentCourse);
          // 处理嵌入xep同步教材版本
          if (
            userPreference &&
            (userPreference.bookVersionId || userPreference.textbookId) &&
            this.isInIframe
          ) {
            let { bookVersionId, textbookId } = userPreference;
            // xep中选中了对应的教材 那么就先从当前课程中的课本列表中查找是否有当前教材
            // console.log(
            //   " currentCourse.bookList",
            //   currentCourse.bookList.length,
            //   bookVersionId,
            //   textbookId
            // );
            let currentTextBookIndex = currentCourse?.bookList?.findIndex(
              (item) => {
                return (
                  item.versionId == Number(bookVersionId) &&
                  item.bookId == Number(textbookId)
                );
              }
            );
            // console.log("currentTextBookIndex", currentTextBookIndex);
            if (currentTextBookIndex == -1 || !currentTextBookIndex) {
              // 当前教材不存在
              // console.log("修改当前课程下的教材");
              this.changeTextBook(textbookId, currentCourse);
            } else {
              // 如果同步的教材在当前教材列表中要移动到首位
              // console.log("currentCourse", currentCourse);
              currentTextBookIndex != 0 &&
                currentCourse.bookList.unshift(
                  currentCourse.bookList.splice(currentTextBookIndex, 1)[0]
                );
            }
          }
        } else {
          currentCourse = courses[0];
          this.setCurrentCourse(currentCourse);
        }
        currentCourse.isLastUsedCourse = result.isLastUsedCourse;
        !this.isInIframe &&
          localStorage.setItem(
            `${this.userInfo.userId}-` + CURRENTCOURSE,
            JSON.stringify(currentCourse)
          );
      }
      // console.log("currentCourse-----", currentCourse);
      // this.setCurrentCourse(currentCourse);
    },
    // 获取当前课程
    async getUserCurrentReadCourse() {
      let data = await getStageSubjectList();
      // this.stageSubjectList = data.result || [];
      this.changeStageSubjectList(data.result);
      let { result } = await getUserUsedCourse();
      if (result) {
        let { stageId, subjectId } = result;
        this.stageSubjectList.forEach((stage) => {
          if (stage.id == stageId) {
            stage.subjectList.forEach((subject) => {
              if (subject.id == subjectId) {
                let currentCourse = subject.course;
                currentCourse.stageId = stage.id;
                currentCourse.stageName = stage.name;
                currentCourse.subjectId = subject.id;
                currentCourse.subjectName = subject.name;
                this.setCurrentReadCourse(currentCourse);
              }
            });
          }
        });
      }
      this.changeHasAiUsedCourses(!!result);
      // console.log('result---',result)
      // if (result) {
      //   this.setCurrentReadReadCourse(result);
      // }
      // let currentReadCourse = localStorage.getItem(CURRENTREADCOURSE) || null;
      // if (currentReadCourse) {
      //   this.setCurrentReadReadCourse(JSON.parse(currentReadCourse));
      // }
    },
    async changeTextBook(textbookId, currentCourse) {
      if (!textbookId) {
        return;
      }
      console.log(
        "textbookDetail---------------  ",
        textbookId,
        this?.currentCourse?.courseId || currentCourse?.courseId
      );
      let data = await addTextbook({
        textbookId: Number(textbookId),
        courseId: this?.currentCourse?.courseId || currentCourse?.courseId,
      });
      const { result: textbookDetail } = await getTextbookDetail({
        textbookId,
      });

      if (data.result) {
        console.log("currentCourse.bookLis", currentCourse.bookList);
        this.$set(this?.currentCourse || currentCourse, "bookList", [
          textbookDetail,
          ...currentCourse.bookList,
        ]);
        // await this.getUserCourses(false);
      }
    },
    // 获取用户课程
    async getUserCourses(
      isSelectCourse = false,
      isSetCurrentCourse = true,
      productId = 0
    ) {
      // console.log(
      //   "isSelectCourse,isSetCurrentCourse",
      //   isSelectCourse,
      //   isSetCurrentCourse
      // );
      // 1=AI阅读
      // 2=AI科学
      // 3=上好课
      // 4=仿真实验室
      // 5=资源库
      // 6=校本资源库
      // const data = await getUserCoursesBooks();
      const data = await getCourseList({
        productId: this.productId || productId,
      });
      data.result = data.result || [];
      // console.log("课程列表", data);
      if (data.code === 200 && data?.result) {
        // this.setCourses(data.result);
        data.result.forEach((item) => {
          if (item?.courseList?.length) {
            item.courseList.forEach((course) => {
              course.stageId = item.id;
            });
          }
        });
        // 存储用户的教材到vuex的bookList
        this.setCourses(data.result);
        !isSetCurrentCourse ? this.changeIsAddNoAuthorizedCourse(true) : null;
        // data.result?.length &&
        //   isSetCurrentCourse &&
        //   isSelectCourse &&
        //   this.selectCourse(data.result[0]);
        isSetCurrentCourse
          ? await this.getCurrentCourse(
              data.result || [],
              isSelectCourse,
              productId
            )
          : null;
      } else {
        await this.getCurrentCourse(
          data.result || [],
          isSelectCourse,
          productId
        );
      }
      // console.log('currentCourse',this.currentCourse)
      this.currentStage = this.currentCourse
        ? this.currentCourse.stageId
        : null;
    },
    // 获取课程的详情
    async getCourseDetail(courseId) {
      const data = await getCourseDetail({
        courseId,
      });
      if (data.code === 200) {
        return data.result;
      }
      return null;
    },
    // 选中课程
    async selectCourse(course) {
      console.log("设置当前的课程---", course);
      this.setCurrentCourse(course);
      !this.isInIframe &&
        localStorage.setItem(
          `${this.userInfo.userId}-` + CURRENTCOURSE,
          JSON.stringify(course)
        );
      this.currentTabId = 1;
      this.isBagVisible = false;
      this.currentStage = this.currentCourse.stageId;
      this.updateQuery && this.updateQuery({}, true);
    },
    sendTongjiData(type, xueduan, xueke, trigger_type = "主动") {
      tracker.handleSendTongji({
        $event_name: "set_textbook_course_popup",
        operate_type: type,
        popup_name: "课程设置",
        trigger_type,
        xueduan,
        xueke,
        banben: "",
        cebie: "",
      });
    },
    async queryToSchoolBased(isMySchoolBase = false) {
      let data = await getUserCoursesBooks();
      let { result: stages } = await getSchoolStages(true);
      let courses = data.result;
      let course = null;
      let currentBook = null;
      // let versionId = null;
      let userStageId = this.currentCourse.stageId || 0;
      let userSubjectId = this.currentCourse.subjectId || 0;
      let userTextBookId = Number(Cookie.get(userSettingTextBookId)) || 0;
      let params = {};
      if (userStageId && userSubjectId) {
        courses.forEach((item) => {
          if (item.stageId == userStageId && item.subjectId == userSubjectId) {
            course = item;
            item.bookList.forEach((book) => {
              if (userTextBookId && book.bookId == userTextBookId) {
                currentBook = book;
              }
            });
            if (!userTextBookId) {
              currentBook = course.bookList[0];
              // versionId = currentBook && course.bookList[0].versionId;
            }

            return;
          }
        });
        // 如果course不存在说明就是之前切换课程但是没有选择教材下次在进入到校本资源页面中找不到对应保存的教材 或者说是上次切换了课程因为现在不需要保存
        if (!course) {
          stages.forEach((item) => {
            if (item.id == userStageId) {
              item.subjectList.forEach((subject) => {
                subject.course.subjectId = subject.id;
                subject.course.stageName = item.name;
                subject.course.stageId = item.id;
                subject.course.subjectName = subject.name;
                if (subject.id == userSubjectId) {
                  course = subject.course;
                  currentBook = null;
                }
              });
            }
          });
        }
      } else {
        course = courses[0];
        let firstBook = course.bookList[0];
        currentBook =
          firstBook && firstBook.versionName == "不限"
            ? course.bookList[1]
            : firstBook;

        // versionId = currentBook ? currentBook.versionId : 0;
      }
      // console.log("courses", course);
      !isMySchoolBase ? (params.courseId = course.courseId) : null;
      !isMySchoolBase ? (params.stageId = course.stageId) : null;
      !isMySchoolBase ? (params.subjectId = course.subjectId) : null;
      params.pageIndex = pageIndex;
      // console.log("pageSize1", this.pageSize);
      params.pageSize = this.pageSize;
      if (currentBook) {
        // params.textbookId = currentBook.bookId;
        // params.versionId = versionId;
      } else if (!currentBook && userTextBookId) {
        // params.textbookId = userTextBookId;
      }
      let { year, term, grade } = handleFirstUseScope();
      // console.log("grade", grade);
      year ? (params.schoolYear = year) : null;
      term ? (params.term = term) : null;
      grade ? (params.gradeIds = grade) : null;
      // console.log('params',params)
      return params;
    },
    async judgeCurrentAuthorized(course) {
      // 工作台云资源学段学科权限
      let { stageId, subjectId } = course;
      let isAuthorized = true;
      if (!this.stageListAndSubjects.length) {
        let { result: stageListAndSubjects } = await getStages();
        // console.log('result',result)
        this.stageListAndSubjects = stageListAndSubjects;
      }
      let stage = this.stageListAndSubjects.find(
        (stage) => stage.id == stageId
      );
      if (!stage) {
        // 选择的是用户无权限的学段
        isAuthorized = false;
      } else {
        let subject = stage.subjectList.find(
          (subject) => subject.id == subjectId
        );
        if (!subject) {
          // 选择的是用户无权限的学科
          isAuthorized = false;
        }
      }
      return isAuthorized;
    },
    // 用户添加课程
    async addUseCourse(
      params,
      trigger_type,
      isSelectCourse = false,
      isShowTip = true,
      isSchoolBased = false
    ) {
      // console.log("添加课程");
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      let isAuthorized = await this.judgeCurrentAuthorized(params);
      // console.log("是否有权限", isAuthorized);
      let isSetCurrentCourse =
        (isSchoolBased && isAuthorized) || !isSchoolBased;
      const result = await addCourse({
        stageId: params.stageId,
        subjectId: params.subjectId,
      });
      if (result.code === 200) {
        console.log("result", result);
        if (isShowTip) {
          Message({
            message: "添加成功",
            type: "success",
            duration: 2 * 1000,
          });
          this.sendTongjiData(
            "提交成功",
            params.stageName,
            params.subjectName,
            trigger_type
          );
        }
        await this.getUserCourses(isSelectCourse, isSetCurrentCourse);
        isShowTip && this.$refs.addCourse.cancel();
      } else if (result.code === 101) {
        if (isShowTip) {
          this.sendTongjiData(
            "提交失败",
            params.stageName,
            params.subjectName,
            trigger_type
          );
          Message({
            message: result.result.message || "添加失败",
            type: "warning",
            duration: 2 * 1000,
          });
          this.$refs.addCourse.cancel();
        }
      }
      this.isLoading = false;
    },
    async updateLastUsedCourse(params) {
      let data = await updateLastUsedCourse({
        ...params,
        productId: this.productId,
      });
      // console.log("---data", data);
    },
    judgeProductTypeId() {
      let path = this.$route.path;
      let productId = 0;
      // let isOnlyScsy = false;
      let isSyncContent = path.indexOf("/shk") > -1;
      let isAiRead = path.indexOf("/read") > -1;
      let isAiKx = path.indexOf("/sci") > -1;
      let isLab = path.indexOf("/lab") > -1;
      let isZyk = path.indexOf("/zyk") > -1;

      // 1=AI阅读
      // 2=AI科学
      // 3=上好课
      // 4=仿真实验室
      // 5=资源库
      // 6=校本资源库
      // let roles = this.userInfo.roles || [];
      if (isLab) {
        productId = 4;
      } else if (isSyncContent) {
        productId = 3;
      } else if (isAiRead) {
        productId = 1;
      } else if (isAiKx) {
        productId = 2;
      } else if (isZyk) {
        productId = 5;
      }
      this.productId = productId;
    },
    // 获取学段学科，标记用户已经添加过的项
    async getStages(selectedCourses, isSchoolBased, isAddCoursesAgain = false) {
      // let data = {};

      // if (roles.length == 1 && roles[0].simpleName.indexOf("scsy") > -1) {
      //   // 仅有实操实验
      //   isOnlyScsy = true;
      // }
      // if (
      //   ((path.indexOf("/lab") > -1 &&
      //   path.indexOf("/lab/playreport") == -1 &&
      //   path.indexOf("/lab/visitreport") == -1) ||
      //     isOnlyScsy) &&
      //   !isSchoolBased
      // ) {
      //   productId = 4;
      //   // console.log("实验权限");
      //   // data.code = 200;
      //   // let { result } = await getScsyStageAndSubjectList()
      //   // data.result = this.scsyStageListAndSubjects || [];
      // } else {
      //   if (isSchoolBased) {
      //     productId = 6
      //     // data = await getSchoolStages(true);
      //   } else if (isSyncContent) {
      //     // console.log("isSyncContent", this.syncStageListAndSubjects);
      //     // data.code = 200;
      //     // data.result = this.syncStageListAndSubjects;
      //     productId = 3;
      //   } else if(isAiRead){
      //     productId = 1;
      //   }else if(isAiKx){
      //     productId = 2
      //   }
      //   // else {
      //   //   data = await getStages();
      //   // }
      //   // data = isSchoolBased ? await getSchoolStages(true) :  isSyncContent ? this.syncStageListAndSubjects : await getStages();
      //   // syncStageListAndSubjects
      // }
      // this.productId = productId;
      let data = await getCourseList({
        productId: this.productId,
      });
      // console.log("data---", data);
      if (data.code === 200) {
        if (data.result.length) {
          this.stages = data.result;
          // this.stages.forEach((stage) => {
          //   stage.subjectList.forEach((subject) => {
          //     const index = selectedCourses.findIndex((item) => {
          //       return (
          //         item.stageId === stage.id && item.subjectId === subject.id
          //       );
          //     });
          //     index >= 0 ? (subject.disable = true) : (subject.disable = false);
          //   });
          // });
        }
      } else if (data.code === 403) {
        Message({
          message:
            (data.result && data.result.message) ||
            "该用户无可用学段，请确认学校是否开通网校通!",
          type: "error",
          duration: 2 * 1000,
        });
      }
    },
    // 打开添加用户课程弹窗
    openCourse(
      selectedCourses,
      triggerType = "主动",
      isSchoolBased = false,
      isAddCoursesAgain = false
    ) {
      // isAddCoursesAgain是否重新添加课程
      // debugger
      console.log("----打开课程---");
      this.sendTongjiData("触发", "", "", triggerType);
      // 获取学段学科
      this.getStages(selectedCourses, isSchoolBased, isAddCoursesAgain);
      this.isAddCourseVisible = true;
      this.isBagVisible = false;
    },
    hideMenu() {
      // console.log("点击3");
      const that = this;
      document.addEventListener("click", function (event) {
        const target = event.target;
        const btn = document.querySelector(".icon-switch");
        const el = document.querySelector(".bag");
        // console.log("target", target);
        if ((el && (target === el || el.contains(target))) || target === btn) {
          return;
        } else {
          // console.log('this',that)
          that.isBagVisible = false;
          that.bookDialogVisible = false;
        }
      });
    },
  },
};
